import React, { useEffect, useMemo, useState } from 'react';
import { getNaiveBaselines } from '../../../../../controller/admin/baseline/naiveBaseline';
import MenuItem from '../../../../../atomicDesign/atoms/MenuItem';
import Select from '../../../../../atomicDesign/atoms/Select';

type NaiveBaselineType = {
  _id: string;
  _buildingName?: string;
  createdAt?: string;
  _building: string;
  active?: boolean;
};

type Props = {
  _building: string;
  baselineId: string;
  onChangeBaselineId: (id: string) => void;
};

export default function AuditLog({
  _building,
  baselineId,
  onChangeBaselineId,
}: Props) {
  const [baselines, setBaselines] = useState<NaiveBaselineType[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    getNaiveBaselines()
      .then((data) => {
        if (cancelled) return;
        setBaselines(Array.isArray(data) ? data : []);
      })
      .catch((error) => {
        if (cancelled) return;
        console.error('Error fetching baselines:', error);
        setBaselines([]);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);
  const filteredBaselines = useMemo(() => {
    return baselines
      .filter((b) => b._building === _building)
      .sort((a, b) => {
        if (a.active !== b.active) {
          return a.active ? -1 : 1;
        }
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return dateB - dateA;
      });
  }, [baselines, _building]);

  useEffect(() => {
    if (!baselineId && filteredBaselines.length > 0) {
      onChangeBaselineId(filteredBaselines[0]._id);
    }
  }, [baselineId, filteredBaselines, onChangeBaselineId]);

  const selectedValue =
    baselineId && filteredBaselines.some((b) => b._id === baselineId)
      ? baselineId
      : '';

  return (
    <Select
      value={selectedValue}
      setValue={(v) => onChangeBaselineId(String(v))}
      fullWidth
      size="small"
      disabled={loading || filteredBaselines.length === 0}
      displayEmpty
    >
      {filteredBaselines.map((b) => (
        <MenuItem
          key={b._id}
          value={b._id}
          sx={{ color: b.active ? '#2e7d32' : '#a15c00' }}
        >
          {'Baseline' +
            (b.createdAt
              ? ` ${new Date(b.createdAt).toLocaleDateString()} ${new Date(
                  b.createdAt
                ).toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })}`
              : '')}
        </MenuItem>
      ))}
    </Select>
  );
}
